import React, { useEffect } from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import './ValueSetDialogIncExc.css';

const filterColumns = [
    { id: 'property', label: 'Property', minWidth: 150 },
    { id: 'op', label: 'Operation', minWidth: 170 },
    { id: 'value', label: 'Value', minWidth: 170 },
];

const conceptColumns = [
    { id: 'code', label: 'Code', minWidth: 150 },
    { id: 'display', label: 'Display', minWidth: 170 },
    { id: 'designation', label: 'Designation', minWidth: 170 },
];

const useStyles = makeStyles({
    root: {
        width: '100%',
        height: '100%',
    },
});

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: '#383838',
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);

function displayProperty(title, rawValue) {
    var value = '';

    switch (typeof rawValue) {
        case 'string':
            value = displayString(rawValue);
            break;
        case 'undefined':
            value = displayString(rawValue);
            break;
        default:
            //console.log(typeof rawValue);
            value = 'XXX';
    }

    return (
        <div className="vsDialogData__itemContainer">
            <div className="vsDialogData__itemLabel">{title}</div>
            <div className="vsDialogData__itemValue">{value}</div>
        </div>
    );
}

function displayString(x) {
    //console.log("xxx", x);
    if (x !== undefined) {
        return x;
    } else {
        return <span className="nullItem">null</span>;
    }
}

function displayFilters(x) {
    var cntExclude = (x) ? x.length : 0;
    if (cntExclude > 0) {
        return (
            <React.Fragment>
                <div className="vs__incExlType">ValueSet Filter</div>
                <TableContainer className="vsTable__incExlContainer">
                    <Table stickyHeader className="vsTable_tableHeader" size="small" aria-label="sticky table">
                        <TableHead className="vsTable_tableHeader">
                            <TableRow>
                                {filterColumns.map((column) => (
                                    <StyledTableCell
                                        key={column.id}
                                        align={column.align}
                                        style={{ minWidth: column.minWidth }}
                                    >
                                        {column.label}
                                    </StyledTableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {x.map((row) => {
                                return (
                                    <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                                        <TableCell key={filterColumns[0].id} align={filterColumns[0].align}>
                                            {row[filterColumns[0].id]}
                                        </TableCell>

                                        <TableCell key={filterColumns[1].id} align={filterColumns[1].align}>
                                            {displayString(row[filterColumns[1].id])}
                                        </TableCell>

                                        <TableCell key={filterColumns[2].id} align={filterColumns[2].align}>
                                            {row[filterColumns[2].id]}
                                        </TableCell>

                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
            </React.Fragment>
        )
    }
}

function displayConcepts(x) {
    var cntExclude = (x) ? x.length : 0;
    if (cntExclude > 0) {
        return (
            <React.Fragment>
                <div className="vs__incExlType">ValueSet Concepts</div>
                <TableContainer className="vsTable__incExlContainer">
                    <Table stickyHeader className="vsTable_tableHeader" size="small" aria-label="sticky table">
                        <TableHead className="vsTable_tableHeader">
                            <TableRow>
                                {conceptColumns.map((column) => (
                                    <StyledTableCell
                                        key={column.id}
                                        align={column.align}
                                        style={{ minWidth: column.minWidth }}
                                    >
                                        {column.label}
                                    </StyledTableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {x.map((row) => {
                                return (
                                    <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                                        <TableCell key={conceptColumns[0].id} align={conceptColumns[0].align}>
                                            {row[conceptColumns[0].id]}
                                        </TableCell>

                                        <TableCell key={conceptColumns[1].id} align={conceptColumns[1].align}>
                                            {displayString(row[conceptColumns[1].id])}
                                        </TableCell>

                                        <TableCell key={filterColumns[2].id} align={filterColumns[2].align}>
                                            {row[filterColumns[2].id]}
                                        </TableCell>

                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
            </React.Fragment>
        )
    }
}

function displayValueSets(x) {
    //console.log("vs", x);
    if (x) {
        return (
            <React.Fragment>
                <div className="vs__incExlType__vs">ValueSets </div>
                <TableContainer className="vsTable__incExlContainer-vs">
                    <Table stickyHeader className="vsTable_tableHeader" size="small" aria-label="sticky table">
                        <TableHead className="vsTable_tableHeader">
                            <TableRow>
                                <StyledTableCell key="hdrvs" align="left" style={{ minWidth: 200 }}>
                                    ValueSet References
                                </StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {x.map((row, index) => {
                                return (
                                    <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                                        <TableCell key={"vs" + index} align="left">
                                            {row}
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
            </React.Fragment>
        )
    }
}

export default function ValueSetDialogIncExc(props) {
    const classes = useStyles();

    useEffect(() => {
        if (props) {
            //console.log('props', props.rule);
        }
    });

    return (
        <Paper className={classes.root}>
            <div className="vsDialogData">
                <div className="vsDialogData__left">
                    {displayProperty('system', props.rule.system)}
                    {displayProperty('version', props.rule.version)}
                    {displayConcepts(props.rule.concept)}
                    {displayFilters(props.rule.filter)}
                    {displayValueSets(props.rule.valueSet)}
                </div>
            </div>
        </Paper>
    );
}
